const Icons = {
  check: 'e900',
  checks: 'e901',
  activesessions: 'e902',
  add: 'e903',
  add_reaction: 'e904',
  addboost: 'e905',
  addmember_filled: 'e906',
  adduser: 'e907',
  admin: 'e908',
  ads: 'e909',
  align_center: 'e90a',
  align_left: 'e90b',
  align_right: 'e90c',
  animals: 'e90d',
  animations: 'e90e',
  app_expand: 'e90f',
  app_shrink: 'e910',
  archive: 'e911',
  arrow_down: 'e912',
  arrow_next: 'e913',
  arrow_prev: 'e914',
  arrowcircle: 'e915',
  arrowhead: 'e916',
  attach: 'e917',
  audio_repeat: 'e918',
  audio_repeat_single: 'e919',
  author_hidden: 'e91a',
  avatarnext: 'e91b',
  avatarprevious: 'e91c',
  aversion: 'e91d',
  back: 'e91e',
  binfilled: 'e91f',
  bold: 'e920',
  bomb: 'e921',
  boost: 'e922',
  boostcircle: 'e923',
  bot_filled: 'e924',
  botcom: 'e925',
  bots: 'e926',
  brightness: 'e927',
  brush: 'e928',
  bubblereply: 'e929',
  bug: 'e92a',
  calendar: 'e92b',
  calendarfilter: 'e92c',
  camera: 'e92d',
  cameraadd: 'e92e',
  captiondown: 'e92f',
  captionup: 'e930',
  car: 'e931',
  card: 'e932',
  card_outline: 'e933',
  cash_circle: 'e934',
  channel: 'e935',
  channel_filled: 'e936',
  channelviews: 'e937',
  chatspinned: 'e938',
  chatsplaceholder: 'e939',
  check1: 'e93a',
  checkbox: 'e93b',
  checkboxblock: 'e93c',
  checkboxempty: 'e93d',
  checkboxon: 'e93e',
  checkretract: 'e93f',
  checkround: 'e940',
  checkround_filled: 'e941',
  clock: 'e942',
  close: 'e943',
  clouddownload: 'e944',
  collapse: 'e945',
  colorize: 'e946',
  comments: 'e947',
  commentssticker: 'e948',
  contrast: 'e949',
  copy: 'e94a',
  crop: 'e94b',
  cross: 'e94c',
  crossgif: 'e94d',
  crossround: 'e94e',
  crossstar: 'e94f',
  darkmode: 'e950',
  data: 'e951',
  delete: 'e952',
  delete_filled: 'e953',
  deletedaccount: 'e954',
  deleteleft: 'e955',
  deleteuser: 'e956',
  devices: 'e957',
  document: 'e958',
  down: 'e959',
  download: 'e95a',
  dragfiles: 'e95b',
  dragmedia: 'e95c',
  eats: 'e95d',
  edit: 'e95e',
  email: 'e95f',
  endcall_filled: 'e960',
  enhance: 'e961',
  enter: 'e962',
  equalizer: 'e963',
  expand: 'e964',
  eye: 'e965',
  eye1: 'e966',
  eye2: 'e967',
  eyecross_outline: 'e968',
  factcheck: 'e969',
  fade: 'e96a',
  fast_forward: 'e96b',
  fast_rewind: 'e96c',
  favourites: 'e96d',
  flag: 'e96e',
  flip: 'e96f',
  flip_image_horizontal: 'e970',
  folder: 'e971',
  fontframe: 'e972',
  fontframe_bg: 'e973',
  fontframe_outline: 'e974',
  fontsize: 'e975',
  forward: 'e976',
  forward_filled: 'e977',
  free_transform: 'e978',
  fullscreen: 'e979',
  gc_microphone: 'e97a',
  gc_microphoneoff: 'e97b',
  geometric_digit_0: 'e97c',
  geometric_digit_1: 'e97d',
  geometric_digit_2: 'e97e',
  geometric_digit_3: 'e97f',
  geometric_digit_4: 'e980',
  geometric_digit_5: 'e981',
  geometric_digit_6: 'e982',
  geometric_digit_7: 'e983',
  geometric_digit_8: 'e984',
  geometric_digit_9: 'e985',
  geometric_dot: 'e986',
  geometric_letter_x: 'e987',
  gifs: 'e988',
  gift: 'e989',
  gift_premium: 'e98a',
  grain: 'e98b',
  group: 'e98c',
  group_filled: 'e98d',
  groupmedia: 'e98e',
  groupmediaoff: 'e98f',
  hand: 'e990',
  help: 'e991',
  hide: 'e992',
  highlights: 'e993',
  image: 'e994',
  image_original: 'e995',
  info: 'e996',
  info2: 'e997',
  italic: 'e998',
  key: 'e999',
  keyboard: 'e99a',
  lamp: 'e99b',
  language: 'e99c',
  largepause: 'e99d',
  largeplay: 'e99e',
  left: 'e99f',
  limit_chat: 'e9a0',
  limit_chats: 'e9a1',
  limit_file: 'e9a2',
  limit_folders: 'e9a3',
  limit_link: 'e9a4',
  limit_pin: 'e9a5',
  link: 'e9a6',
  link_paid: 'e9a7',
  list: 'e9a8',
  listscreenshare: 'e9a9',
  livelocation: 'e9aa',
  location: 'e9ab',
  lock: 'e9ac',
  lockoff: 'e9ad',
  loginlogodesktop: 'e9ae',
  loginlogomobile: 'e9af',
  logout: 'e9b0',
  mac_command_key: 'e9b1',
  mediaspeed_empty: 'e9b2',
  mediaspoiler: 'e9b3',
  mediaspoileroff: 'e9b4',
  mention: 'e9b5',
  menu: 'e9b6',
  message: 'e9b7',
  message_jump: 'e9b8',
  message_quote: 'e9b9',
  messageunread: 'e9ba',
  microphone: 'e9bb',
  microphone_crossed: 'e9bc',
  microphone_crossed_filled: 'e9bd',
  microphone_filled: 'e9be',
  minus: 'e9bf',
  monospace: 'e9c0',
  more: 'e9c1',
  multistories: 'e9c2',
  mute: 'e9c3',
  muted: 'e9c4',
  mynotes: 'e9c5',
  newchannel: 'e9c6',
  newchannel_filled: 'e9c7',
  newchat_filled: 'e9c8',
  newgroup: 'e9c9',
  newgroup_filled: 'e9ca',
  newprivate: 'e9cb',
  newprivate_filled: 'e9cc',
  newtab: 'e9cd',
  next: 'e9ce',
  nochannel: 'e9cf',
  noncontacts: 'e9d0',
  nosound: 'e9d1',
  online: 'e9d2',
  passwordoff: 'e9d3',
  pause: 'e9d4',
  permissions: 'e9d5',
  person: 'e9d6',
  phone: 'e9d7',
  phone_filled: 'e9d8',
  pin: 'e9d9',
  pin2: 'e9da',
  pinlist: 'e9db',
  pinned_filled: 'e9dc',
  pinnedchat: 'e9dd',
  pip: 'e9de',
  play: 'e9df',
  playback_05: 'e9e0',
  playback_15: 'e9e1',
  playback_1x: 'e9e2',
  playback_2x: 'e9e3',
  plus: 'e9e4',
  plusround: 'e9e5',
  poll: 'e9e6',
  premium_addone: 'e9e7',
  premium_avatars: 'e9e8',
  premium_badge: 'e9e9',
  premium_colors: 'e9ea',
  premium_double: 'e9eb',
  premium_emoji: 'e9ec',
  premium_filesize: 'e9ed',
  premium_lastseen: 'e9ee',
  premium_limits: 'e9ef',
  premium_lock: 'e9f0',
  premium_management: 'e9f1',
  premium_noads: 'e9f2',
  premium_privacy: 'e9f3',
  premium_reactions: 'e9f4',
  premium_restrict: 'e9f5',
  premium_speed: 'e9f6',
  premium_status: 'e9f7',
  premium_stickers: 'e9f8',
  premium_tags: 'e9f9',
  premium_transcription: 'e9fa',
  premium_translate: 'e9fb',
  premium_unlock: 'e9fc',
  premium_wallpaper: 'e9fd',
  previous: 'e9fe',
  promote: 'e9ff',
  quote: 'ea00',
  quote_outline: 'ea01',
  radiooff: 'ea02',
  radioon: 'ea03',
  reactions: 'ea04',
  reactions_filled: 'ea05',
  readchats: 'ea06',
  recent: 'ea07',
  redo: 'ea08',
  replace: 'ea09',
  reply: 'ea0a',
  reply_filled: 'ea0b',
  restrict: 'ea0c',
  revenue: 'ea0d',
  rightpanel: 'ea0e',
  rotate: 'ea0f',
  rotate_left: 'ea10',
  rotate_right: 'ea11',
  round_chats_filled: 'ea12',
  saturation: 'ea13',
  saved: 'ea14',
  savedmessages: 'ea15',
  schedule: 'ea16',
  scheduled: 'ea17',
  search: 'ea18',
  select: 'ea19',
  send: 'ea1a',
  send2: 'ea1b',
  sending: 'ea1c',
  sendingerror: 'ea1d',
  settings: 'ea1e',
  settings_clipped_corner: 'ea1f',
  settings_filled: 'ea20',
  shadows: 'ea21',
  sharescreen_filled: 'ea22',
  sharpen: 'ea23',
  shipping: 'ea24',
  shuffle: 'ea25',
  smallscreen: 'ea26',
  smile: 'ea27',
  speaker: 'ea28',
  speakerfilled: 'ea29',
  speakeroff: 'ea2a',
  speakerofffilled: 'ea2b',
  spoiler: 'ea2c',
  sport: 'ea2d',
  star: 'ea2e',
  star_filled: 'ea2f',
  statistics: 'ea30',
  stickers: 'ea31',
  stickers_face: 'ea32',
  stop: 'ea33',
  stories: 'ea34',
  storyreply: 'ea35',
  storyrepost: 'ea36',
  strikethrough: 'ea37',
  tag: 'ea38',
  tag_add: 'ea39',
  tag_crossed: 'ea3a',
  tag_filter: 'ea3b',
  tag_name: 'ea3c',
  text: 'ea3d',
  textedit: 'ea3e',
  timer: 'ea3f',
  tip: 'ea40',
  tools: 'ea41',
  topics: 'ea42',
  transcribe: 'ea43',
  unarchive: 'ea44',
  unclaimed: 'ea45',
  underline: 'ea46',
  undo: 'ea47',
  unmute: 'ea48',
  unpin: 'ea49',
  unread: 'ea4a',
  up: 'ea4b',
  user: 'ea4c',
  username: 'ea4d',
  videocamera: 'ea4e',
  videocamera_crossed_filled: 'ea4f',
  videocamera_filled: 'ea50',
  videochat: 'ea51',
  vignette: 'ea52',
  volume_down: 'ea53',
  volume_mute: 'ea54',
  volume_off: 'ea55',
  volume_up: 'ea56',
  warmth: 'ea57',
  webview: 'ea58',
  win_key: 'ea59',
  zoomin: 'ea5a',
  zoomout: 'ea5b'
};

export default Icons;
